module.exports = __webpack_public_path__ + "img/kas_keluar.ef9f538f.png";